import { Menu } from 'components/atoms/dropdown';
import { MoveTaskSubMenu } from 'components/molecules/tasks/more-actions/move-task-sub-menu';
import { withAccess } from 'hooks/rbac/withAccess';

export const RbacMenuHeader = withAccess(Menu.Header);
export const RbacMenuItem = withAccess(Menu.Item);
export const RbacMenuItemDelete = withAccess(Menu.ItemDelete);
export const RbacMenuItemEdit = withAccess(Menu.ItemEdit);
export const RbacSubMenu = withAccess(Menu.SubMenu);
export const RbacMoveTaskSubMenu = withAccess(MoveTaskSubMenu);
